import { useEffect, useState } from 'react';

/**
 * Custom hook that returns a boolean representing the result of the media query.
 *
 * @param {string} query - The media query string to match against
 * @return {boolean} The boolean representing the result of the media query
 */
export function useMediaQuery(query) {
  const [value, setValue] = useState(false);

  useEffect(() => {
    function onChange(event) {
      setValue(event.matches);
    }

    const result = matchMedia(query);
    result.addEventListener('change', onChange);
    setValue(result.matches);

    return () => result.removeEventListener('change', onChange);
  }, [query]);

  return value;
}
